import { styled } from 'styles';

export const StyledNotifications = styled.div`
  position: fixed;
  right: ${({ theme }) => theme.spacing.absolute.medium};
  top: ${({ theme }) => theme.spacing.absolute.medium};
  user-select: none;
  width: 25em;
  z-index: 100;

  @media (max-width: 576px) {
    left: ${({ theme }) => theme.spacing.absolute.smaller};
    right: ${({ theme }) => theme.spacing.absolute.smaller};
    top: ${({ theme }) => theme.spacing.absolute.smaller};
    width: auto;
  }
`;

StyledNotifications.displayName = 'Notifications.Styled';
